
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F0A53D","d":"M40.17 31.54c5.25 0 9.5-4.37 9.5-9.77 0-5.4-4.25-9.77-9.5-9.77a9.64 9.64 0 00-9.5 9.77c0 5.4 4.25 9.77 9.5 9.77z"}}),_c('path',{attrs:{"fill":"#EAD4AA","d":"M20.54 31.54c3.4 0 6.17-2.84 6.17-6.34s-2.76-6.34-6.17-6.34a6.25 6.25 0 00-6.16 6.34c0 3.5 2.76 6.34 6.16 6.34zm39.1 0c3.4 0 6.16-2.84 6.16-6.34s-2.75-6.34-6.16-6.34a6.25 6.25 0 00-6.16 6.34c0 3.5 2.76 6.34 6.16 6.34zm.03 4.46c-2.63 0-5.02.92-6.99 2.43 3.3 3.3 5.34 7.92 5.34 12.97v8.52h9c2.32 0 4.2-1.91 4.2-4.26v-7.92A11.6 11.6 0 0059.67 36zM21.88 52.28c0-5.45 2.2-10.35 5.66-13.85A11.44 11.44 0 0020.6 36C14.19 36 9 41.25 9 47.74v8A4.24 4.24 0 0013.2 60h8.65v-7.72h.03z"}}),_c('path',{attrs:{"fill":"#F0A53D","d":"M55.67 63c0 2.76-1.97 5-4.38 5H28.93c-2.41 0-4.37-2.24-4.37-5v-8.22c0-9.62 6.3-18.27 14.71-18.73.29 0 .84-.05.82-.05 8.59 0 15.54 7.94 15.54 17.75l.04 8.25v1z"}})])
          )
        }
      }
    